export enum ComplianceName {
  ADDRESS = 'ADDRESS',
  BACKGROUND_CHECKS = 'BACKGROUND_CHECKS',
  BANK_ACCOUNT = 'BANK_ACCOUNT',
  COMMON_BUSINESS_ENTITY = 'COMMON_BUSINESS_ENTITY',
  COMPANY_ADDRESS = 'COMPANY_ADDRESS',
  COMPANY_AU_BUSINESS_ENTITY = 'COMPANY_AU_BUSINESS_ENTITY',
  COMPANY_CA_BUSINESS_ENTITY = 'COMPANY_CA_BUSINESS_ENTITY',
  COMPANY_DE_BUSINESS_ENTITY = 'COMPANY_DE_BUSINESS_ENTITY',
  COMPANY_SG_BUSINESS_ENTITY = 'COMPANY_SG_BUSINESS_ENTITY',
  COMPANY_US_BUSINESS_ENTITY = 'COMPANY_US_BUSINESS_ENTITY',
  CONTRACT_CHANGES = 'CONTRACT_CHANGES',
  CONTRACT_DOC = 'CONTRACT_DOC',
  EMPLOYMENT_COST = 'EMPLOYMENT_COST',
  EMPLOYER_OF_RECORD = 'EMPLOYER_OF_RECORD',
  FREELANCER_AU_BUSINESS_ENTITY = 'FREELANCER_AU_BUSINESS_ENTITY',
  FREELANCER_CA_BUSINESS_ENTITY = 'FREELANCER_CA_BUSINESS_ENTITY',
  FREELANCER_DE_BUSINESS_ENTITY = 'FREELANCER_DE_BUSINESS_ENTITY',
  FREELANCER_DK_BUSINESS_ENTITY = 'FREELANCER_DK_BUSINESS_ENTITY',
  FREELANCER_FR_BUSINESS_ENTITY = 'FREELANCER_FR_BUSINESS_ENTITY',
  FREELANCER_IE_BUSINESS_ENTITY = 'FREELANCER_IE_BUSINESS_ENTITY',
  FREELANCER_SG_BUSINESS_ENTITY = 'FREELANCER_SG_BUSINESS_ENTITY',
  FREELANCER_UK_BUSINESS_ENTITY = 'FREELANCER_UK_BUSINESS_ENTITY',
  FREELANCER_US_BUSINESS_ENTITY = 'FREELANCER_US_BUSINESS_ENTITY',
  FULL_NAME = 'FULL_NAME',
  GLOBAL_CONTRACT_TYPE = 'GLOBAL_CONTRACT_TYPE',
  GLOBAL_CONTRACT_TYPE_HIRE = 'GLOBAL_CONTRACT_TYPE_HIRE',
  IR35 = 'IR35',
  IR35_COMPANY_SETTINGS = 'IR35_COMPANY_SETTINGS',
  ONSITE_PRESENCE = 'ONSITE_PRESENCE',
  PAYE_ACCEPT = 'PAYE_ACCEPT',
  RECRUITER_US_BUSINESS_ENTITY = 'RECRUITER_US_BUSINESS_ENTITY',
  UK_CONTRACT_TYPE = 'UK_CONTRACT_TYPE',
  UK_CONTRACT_TYPE_SOLE_TRADER = 'UK_CONTRACT_TYPE_SOLE_TRADER',
  UK_PAYE_EMPLOYMENT = 'UK_PAYE_EMPLOYMENT',
  UK_PAYE_REQUIRED_CONTRACT_DATES = 'UK_PAYE_REQUIRED_CONTRACT_DATES',
  UK_PAYROLL = 'UK_PAYROLL',
  UK_PAYROLL_CONTRACT_PERIOD = 'UK_PAYROLL_CONTRACT_PERIOD',
  UK_SOLE_TRADER = 'UK_SOLE_TRADER',
  UK_SOLE_TRADER_CLASSIFICATION = 'UK_SOLE_TRADER_CLASSIFICATION',
  UK_STATEMENT_OF_WORK = 'UK_STATEMENT_OF_WORK',
  UK_TAX = 'UK_TAX',
  US_CONTRACT_TYPE = 'US_CONTRACT_TYPE',
  US_TAX = 'US_TAX',
  US_WORKER_CLASSIFICATION = 'US_WORKER_CLASSIFICATION',
  UK_VALID_CONTRACT_SETUP = 'UK_VALID_CONTRACT_SETUP',
  W2_HIRE = 'W2_HIRE',
  FLSA = 'FLSA',
  VALID_VAT = 'VALID_VAT',
}

export function businessEntityCompliances(): ComplianceName[] {
  return [
    ComplianceName.COMMON_BUSINESS_ENTITY,
    ComplianceName.COMPANY_AU_BUSINESS_ENTITY,
    ComplianceName.COMPANY_CA_BUSINESS_ENTITY,
    ComplianceName.COMPANY_DE_BUSINESS_ENTITY,
    ComplianceName.COMPANY_SG_BUSINESS_ENTITY,
    ComplianceName.COMPANY_US_BUSINESS_ENTITY,
    ComplianceName.FREELANCER_AU_BUSINESS_ENTITY,
    ComplianceName.FREELANCER_CA_BUSINESS_ENTITY,
    ComplianceName.FREELANCER_DE_BUSINESS_ENTITY,
    ComplianceName.FREELANCER_DK_BUSINESS_ENTITY,
    ComplianceName.FREELANCER_FR_BUSINESS_ENTITY,
    ComplianceName.FREELANCER_IE_BUSINESS_ENTITY,
    ComplianceName.FREELANCER_SG_BUSINESS_ENTITY,
    ComplianceName.FREELANCER_UK_BUSINESS_ENTITY,
    ComplianceName.FREELANCER_US_BUSINESS_ENTITY,
    ComplianceName.RECRUITER_US_BUSINESS_ENTITY,
  ]
}

export function determinationCompliances(): ComplianceName[] {
  return [
    ComplianceName.IR35,
    ComplianceName.UK_SOLE_TRADER_CLASSIFICATION,
    ComplianceName.US_WORKER_CLASSIFICATION,
  ]
}

export function freelancerBusinessEntityCompliances(): ComplianceName[] {
  return [
    ComplianceName.COMMON_BUSINESS_ENTITY,
    ComplianceName.FREELANCER_AU_BUSINESS_ENTITY,
    ComplianceName.FREELANCER_CA_BUSINESS_ENTITY,
    ComplianceName.FREELANCER_DE_BUSINESS_ENTITY,
    ComplianceName.FREELANCER_DK_BUSINESS_ENTITY,
    ComplianceName.FREELANCER_FR_BUSINESS_ENTITY,
    ComplianceName.FREELANCER_IE_BUSINESS_ENTITY,
    ComplianceName.FREELANCER_SG_BUSINESS_ENTITY,
    ComplianceName.FREELANCER_UK_BUSINESS_ENTITY,
    ComplianceName.FREELANCER_US_BUSINESS_ENTITY,
  ]
}

export function freelancerOnboardingCompliances(): ComplianceName[] {
  return [
    ComplianceName.ADDRESS,
    ComplianceName.FULL_NAME,
    ComplianceName.US_TAX,
    ComplianceName.UK_TAX,
    ...freelancerBusinessEntityCompliances(),
  ]
}
